<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域 -->
            <el-col :span="24">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="搜索">
                        <el-input v-model="searchKeyword" placeholder="请输入菜品名称" clearable
                            @keyup.enter.native="handleSearch"></el-input>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="paginatedList" height="65vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="dishName" label="菜品名称" align="center" width="155" />
                    <el-table-column prop="evaluate" label="菜品评价" align="center" />
                    <el-table-column label="操作" align="center" width="160" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click="handleDelete(scope.row.id)" type="danger" size="small"
                                icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="filteredTotalCount">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getEvaluate, deleteEvaluate } from "@/api/dishevaluate";

export default {
    data() {
        return {
            // 表格数据和分页
            list: [], // 原始完整数据
            loading: false,
            currentPage: 1,
            pageSize: 10,
            // 搜索关键词
            searchKeyword: ''
        };
    },
    computed: {
        // 过滤：仅根据菜品名称搜索
        filteredList() {
            if (!this.searchKeyword) {
                return this.list;
            }
            // 转小写实现不区分大小写搜索
            const keyword = this.searchKeyword.toLowerCase();
            return this.list.filter(item =>
                item.dishName?.toLowerCase().includes(keyword)
            );
        },
        // 过滤后的总条数（用于分页）
        filteredTotalCount() {
            return this.filteredList.length;
        },
        // 分页：基于过滤后的列表
        paginatedList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredList.slice(start, end);
        }
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            this.loading = true;
            getEvaluate({
                userid: localStorage.getItem('userId')
            }).then(response => {
                this.list = response.data;
            }).finally(() => {
                this.loading = false;
            });
        },

        // 搜索（重置页码）
        handleSearch() {
            this.currentPage = 1; // 每次搜索都从第一页开始
        },

        // 切换每页条数
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 切换每页数量时重置页码
        },

        // 切换页码
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        // 行点击事件
        handleRowClick(row) {
            console.log('Row clicked:', row);
        },

        // 删除评价
        handleDelete(id) {
            this.$confirm('此操作将永久删除该评价, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const response = await deleteEvaluate({ id: id });
                    if (response.code === 200) {
                        this.$message.success('删除成功');
                        this.getList(); // 重新加载列表
                    } else {
                        this.$message.error(response.msg || '删除失败');
                    }
                } catch (error) {
                    console.error("删除失败:", error);
                    this.$message.error('操作失败，请稍后重试');
                }
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}
</style>